import storage from './storage';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const toUrl = (path) => {
  if (path.startsWith('http')) return path;
  if (path.startsWith('/')) return `${baseURL}${path}`;
  return `${baseURL}/${path}`;
};

const request = async (path, options = {}) => {
  const token = storage.get('authToken');
  const headers = { ...(options.headers || {}) };
  const isFormData = options.body instanceof FormData;

  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (token && options.auth !== false) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await window.fetch(toUrl(path), {
    ...options,
    headers
  });

  if (options.meta) {
    const contentType = response.headers.get('content-type') || '';
    let data = null;
    if (response.status !== 204 && contentType.includes('application/json')) {
      data = await response.json();
    }
    return { response, data };
  }

  if (options.responseType === 'blob') {
    return response.blob();
  }

  if (options.responseType === 'text') {
    return response.text();
  }

  if (response.status === 204) return null;

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return null;
  }

  return response.json();
};

const apiClient = { request };

export default apiClient;
